/* WAM.js */

import axios from 'axios';

const PZ_BASE_URL_LOGIN_SIGNUP = process.env.REACT_APP_PZ_BASE_URL_LOGIN_SIGNUP;
const PZ_BASE_URL_OTHER = process.env.REACT_APP_PZ_BASE_URL_OTHER;
const BASE_APP = process.env.REACT_APP_NAME;
const BASE_CLIENT = process.env.REACT_APP_CLIENT;
const BASE_VERSION = process.env.REACT_APP_VERSION;
const BASE_BUILD = process.env.REACT_APP_BUILD;
const WAM_URL_LOGIN_SIGNUP = `${PZ_BASE_URL_LOGIN_SIGNUP}{method}.php?client=${BASE_CLIENT}&app=${BASE_APP}&version=${BASE_VERSION}&build=${BASE_BUILD}`;
const WAM_URL_OTHER = `${PZ_BASE_URL_OTHER}{method}.php?client=${BASE_CLIENT}&app=${BASE_APP}&version=${BASE_VERSION}&build=${BASE_BUILD}`;

const WAM = {

  login: async function (username, password) {
    const method = 'WAMLogin';
    const url = WAM_URL_LOGIN_SIGNUP.replace('{method}', method);

    const formData = new FormData();
    formData.append('method', 'WAMLogin');
    formData.append(username.match(/@/) ? 'email' : 'username', username);
    formData.append('password', password);

    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: url,
        data: formData
      })
        .then((response) => {
          return resolve(this.convertToJson(response.data));
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  logout: async function (un, al) {
    const method = 'WAMLogout';
    const url = WAM_URL_OTHER.replace('{method}', method);

    const formData = new FormData();
    formData.append('method', 'WAMLogout');
    formData.append('username', un);
    formData.append('authorized_login_id', al);

    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: url,
        data: formData
      })
        .then((response) => {
          return resolve(response);
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  forgot: async function (username) {
    const method = 'WAMForgotPassword';
    const url = WAM_URL_OTHER.replace('{method}', method);

    const formData = new FormData();
    formData.append('method', 'WAMForgotPassword');
    formData.append(username.match(/@/) ? 'email' : 'username', username);

    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: url,
        data: formData
      })
        .then((response) => {
          return resolve(this.convertToJson(response.data));
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  changeUserPassword: async function (un, al, oldpassword, newpassword) {
    const method = 'WAMChangeUserPassword';
    const url = WAM_URL_OTHER.replace('{method}', method);
    
    const formData = new FormData();
    formData.append('username', un);
    formData.append('authorized_login_id', al);
    formData.append('old_password', oldpassword);
    formData.append('new_password', newpassword);

    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: url,
        data: formData
      })
        .then((response) => {
          return resolve(this.convertToJson(response.data));
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  signup: async function (username, email, password) {
    const method = 'WAMSignup';
    const url = WAM_URL_LOGIN_SIGNUP.replace('{method}', method);

    const formData = new FormData();
    formData.append('method', 'WAMSignup');
    formData.append('username', username);
    formData.append('password', password);
    formData.append('email', email);

    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: url,
        data: formData
      })
        .then((response) => {
          return resolve(this.convertToJson(response.data));
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  getUserProfile: async function ({ username, al }) {
    const method = 'WAMGetUserProfile';
    const url = WAM_URL_OTHER.replace('{method}', method);

    const formData = new FormData();
    formData.append('method', 'WAMGetUserProfile');
    formData.append('username', username);
    formData.append('authorized_login_id', al);

    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: url,
        data: formData
      })
        .then((response) => {
          return resolve(this.convertToJson(response.data));
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  setUserProfile: async function ({ al, username, fullName, description, url, email, photo }) {
    const method = 'WAMSetUserProfile';
    const wamUrl = WAM_URL_OTHER.replace('{method}', method);

    const formData = new FormData();
    formData.append('method', 'WAMSetUserProfile');
    formData.append('authorized_login_id', al);
    formData.append('username', username);

    let countObj = 0;

    if (photo) {
      formData.append(`obj${++countObj}`, `5;${photo.name};`);
      formData.append('Filedata1', photo);
      formData.append('Filename', photo.name);
    }

    if (email) {
      formData.append(`obj${++countObj}`, `7;${email}`);
      formData.append('email', email);
    }
    if (fullName) {
      formData.append(`obj${++countObj}`, `2;${fullName || ''};`);
      formData.append('fullName', fullName || '');
    }
    if (description) {
      formData.append(`obj${++countObj}`, `4;${description || ''};`);
      formData.append('biography', description || '');
    }
    if (url) {
      formData.append(`obj${++countObj}`, `6;${url || ''};`);
      formData.append('site', url || '');
    }

    formData.append('obj_count', countObj.toString());

    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: wamUrl,
        data: formData
      })
        .then((response) => {
          return resolve(this.convertToJson(response.data));
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  changeUserEmail: async function ({ al, username, new_email }) {
    const method = 'WAMChangeUserEmail';
    const url = WAM_URL_OTHER.replace('{method}', method);

    const formData = new FormData();
    formData.append('method', 'WAMChangeUserEmail');
    formData.append('authorized_login_id', al);
    formData.append('username', username);
    formData.append('new_email', new_email);

    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: url,
        data: formData
      })
        .then((response) => {
          return resolve(this.convertToJson(response.data));
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  validateSession: async function (username, authorized_login_id) {
    const method = 'WAMValidateSession';
    const url = WAM_URL_OTHER.replace('{method}', method);

    const formData = new FormData();
    formData.append('method', 'WAMValidateSession');
    formData.append('version', 'v2');
    formData.append('username', username);
    formData.append('authorized_login_id', authorized_login_id);

    return new Promise((resolve, reject) => {
      axios({ method: 'POST', url: url, data: formData})
        .then((response) => {
          return resolve(this.convertToJson(response.data));
        })
        .catch((err) => {
          if (err.response) {
            return reject(err.response.data.message);
          } else {
            return reject();
          }
        });
    });
  },

  listToJson: function (list) {
    let pair;
    const json = {};
    const array = list.split('|');
    for (let i = 0; i < array.length; i++) {
      pair = array[i].split(';');
      json[pair[0].replace(/:/g, '')] = pair[1];
    }
    return json;
  },

  convertToJson: function (value) {
    var hash;
    var myJson = {};
    var hashes = value.slice(value.indexOf("?") + 1).split("&");
    for (var i = 0; i < hashes.length; i++) {
      hash = hashes[i].split("=");
      myJson[hash[0]] = decodeURIComponent(hash[1]);
    }
    return myJson;
  }
};

export default WAM;
